import { getRequest, postRequest } from "../utils/request";

export const forgotPasswordInit = async (email) => getRequest(`/auth/forgot-password-init/${email}`)

export const forgotPasswordChallenge = async (email, code, newPassword, newPasswordConfirm) => postRequest(`/auth/forgot-password`, { email, code, newPassword, newPasswordConfirm })

export const verifyEmailInit = async (email) => getRequest(`/auth/verify-email-init/${email}`)

export const verifyEmailChallenge = async (email, code) => postRequest(`/auth/verify-email`, { email, code })

export const postAcceptTerms = async () => postRequest(`/user/acceptTerms`)
